module.exports = __webpack_public_path__ + "img/aircrew-transfer-img.2a392f4d.jpg";